/* Pia als eigene App auf dem Home-Bildschirm (30.10.2026, Betreiber: „Pia soll nur als Home-Bildschirm-Assistentin für mich arbeiten können“).
   /pia/app: Vollbild fürs Handy, Gesprächsmodus als Startansicht (großer Mikrofon-Knopf, Verlauf, Bestätigungskarten, Vorlesen).
   Der Inhaber spricht hier mit Pia; die Empfänger der Briefings (31.10.2026: Cagla) sehen nur ihren Verlauf mit den Karten. Ohne Anmeldung leitet die Route zum CRM-Login und danach zurück (ProtectedMinimalRoute in App.js).
   Eigenes Manifest NUR auf dieser Seite (Name „Pia“, start_url /pia/app): die Tags kommen beim Öffnen in den <head> und gehen beim
   Verlassen wieder raus – das CRM und alle öffentlichen Seiten bleiben unberührt. Web-Push: derselbe Service Worker /pia-sw.js wie im CRM;
   iOS erlaubt Push nur für Home-Bildschirm-Apps, darum steht hier der Knopf „Mitteilungen“. */
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Bot, Loader2 } from 'lucide-react';
import api from '@/lib/api';
import PiaThread from '@/components/PiaThread';
import PiaPush from '@/components/PiaPush';
import { kontextVon } from '@/components/PiaSchwebeknopf';

const TAGS = [
  ['link', { rel: 'manifest', href: '/pia-app-manifest.json' }],
  ['link', { rel: 'apple-touch-icon', href: '/pia-apple-touch-icon.png?v=2' }],
  ['meta', { name: 'apple-mobile-web-app-capable', content: 'yes' }],
  ['meta', { name: 'mobile-web-app-capable', content: 'yes' }],
  ['meta', { name: 'apple-mobile-web-app-title', content: 'Pia' }],
  ['meta', { name: 'apple-mobile-web-app-status-bar-style', content: 'default' }],
];

function Kopfzeilen() {
  useEffect(() => {
    // vorhandene Manifest-/Icon-Tags (z. B. von /pia) für die Zeit dieser Seite beiseite legen, damit nur unser Manifest gilt
    const alt = [...document.head.querySelectorAll('link[rel="manifest"], link[rel="apple-touch-icon"]')];
    alt.forEach((e) => e.parentNode.removeChild(e));
    const neu = TAGS.map(([tag, attr]) => { const e = document.createElement(tag); Object.entries(attr).forEach(([k, v]) => e.setAttribute(k, v)); return e; });
    const titel = document.title;
    document.title = 'Pia';
    document.head.append(...neu);
    return () => { neu.forEach((e) => e.parentNode && e.parentNode.removeChild(e)); alt.forEach((e) => document.head.appendChild(e)); document.title = titel; };
  }, []);
  return null;
}

export default function PiaApp() {
  const [s, setS] = useState(undefined);
  useEffect(() => { api.get('/assistenz/status').then((r) => setS(r.data)).catch((e) => setS({ fehler: e?.response?.status || 0 })); }, []);

  let inhalt;
  if (s === undefined) inhalt = <div className="flex-1 flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin" /></div>;
  else if (s.fehler === 404) inhalt = <p className="p-6 text-sm text-muted-foreground">Pia ist gerade ausgeschaltet.</p>;
  else if (s.fehler) inhalt = (
    <div className="p-6 space-y-2 text-sm"><p>Pia ist nur für den Inhaber.</p><Link to="/" className="text-marke underline">Zum CRM</Link></div>
  );
  else if (!s.darf_fragen) inhalt = (
    <div className="flex-1 min-h-0 flex flex-col p-3 overflow-y-auto">
      <PiaThread darfFragen={false} hoehe="h-[calc(100dvh-200px)] min-h-[180px]" />
      <div className="pt-3"><PiaPush /></div>
    </div>
  );
  else inhalt = (
    <div className="flex-1 min-h-0 flex flex-col p-3 overflow-y-auto">
      <PiaThread darfFragen gespraech hoehe="h-[calc(100dvh-340px)] min-h-[180px]" kontext={() => kontextVon('/pia/app')} />
      <div className="pt-3"><PiaPush /></div>
    </div>
  );
  return (
    <div className="min-h-[100dvh] flex flex-col bg-background text-foreground" data-testid="pia-app" style={{ paddingTop: 'env(safe-area-inset-top)', paddingBottom: 'env(safe-area-inset-bottom)' }}>
      <Kopfzeilen />
      <header className="flex items-center gap-2 px-4 h-12 border-b border-border shrink-0"><Bot className="w-5 h-5 text-marke" aria-hidden="true" /><h1 className="text-base font-bold">Pia</h1></header>
      {inhalt}
    </div>
  );
}
